export const Detalle = (props) => {
    return (
        <div className="bg-white border rounded-md">
            <div className=" border-gray-200 p-0">
                <div className="sm:divide-y sm:divide-gray-200 ">
                    <div className="py-2 grid grid-cols-3 gap-2 px-3 hover:bg-gray-100">
                        <div className="text-sm font-medium text-gray-500">
                            Nombre comercial
                        </div>
                        <div className="text-sm text-gray-900 sm:col-span-2">
                            {props?.registro?.nombre_comercial}
                        </div>
                    </div>
                    <div className="py-2 grid grid-cols-3 gap-2 px-3 hover:bg-gray-100">
                        <div className="text-sm font-medium text-gray-500">
                            Razon social
                        </div>
                        <div className="text-sm text-gray-900 sm:col-span-2">
                            {props?.registro?.razon_social}
                        </div>
                    </div>
                    <div className="py-2 grid grid-cols-3 gap-2 px-3 hover:bg-gray-100">
                        <div className="text-sm font-medium text-gray-500">
                            NIT
                        </div>
                        <div className="text-sm text-gray-900 sm:col-span-2">
                            {props?.registro?.nit}
                        </div>
                    </div>
                    <div className="py-2 grid grid-cols-3 gap-2 px-3 hover:bg-gray-100">
                        <div className="text-sm font-medium text-gray-500">
                            Direccion
                        </div>
                        <div className="text-sm text-gray-900 sm:col-span-2">
                            {props?.registro?.direccion}
                        </div>
                    </div>
                    <div className="py-2 grid grid-cols-3 gap-2 px-3 hover:bg-gray-100">
                        <div className="text-sm font-medium text-gray-500">
                            Telefono
                        </div>
                        <div className="text-sm text-gray-900 sm:col-span-2">
                            {props?.registro?.telefono}
                        </div>
                    </div>
                    <div className="py-2 grid grid-cols-3 gap-2 px-3 hover:bg-gray-100">
                        <div className="text-sm font-medium text-gray-500">
                            Fecha creacion
                        </div>
                        <div className="text-sm text-gray-900 sm:col-span-2">
                            {props?.registro?.created_at}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
